import classNames from "classnames";
import React from "react";
import { defaultState } from "tsi-common-react/src/apps/reviews/defaults";
import { updateFilterOptionValue } from "tsi-common-react/src/apps/reviews/reducers";
import { RatingGraphic } from "tsi-common-react/src/components/RatingGraphic/index";
import { IReviewQueryFacets } from "tsi-common-react/src/models/reviews";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/store/reducers";
import { formatNumber } from "tsi-common-react/src/utils/format";
import { roundReviewRating } from "tsi-common-react/src/utils/math";

import { HistogramRow, IHistogramRow } from "../HistogramRow";

import styles from "./index.module.scss";

const FACET_TYPE: IReviewQueryFacets = "rating";

export const Histogram = () => {
    const dispatch = useAppDispatch();

    const ratingFacet = useAppSelector((state) => {
        const reviewsState = state.reviews || defaultState;
        return (
            reviewsState.data.facets.find(
                (facet) => facet.type === FACET_TYPE,
            ) || null
        );
    });

    if (!ratingFacet) {
        return null;
    }
    const totalCount = ratingFacet.options
        .map((option) => option.quantity)
        .reduce((memo, qty) => memo + qty, 0);
    const totalScore = ratingFacet.options
        .map((option) => option.quantity * parseInt(`${option.name}`, 10))
        .reduce((memo, score) => memo + score, 0);
    const averageScore = totalScore / totalCount;
    const histogram: IHistogramRow[] = ratingFacet.options.map((option) => {
        return {
            score: parseInt(`${option.name}`, 10),
            count: option.quantity,
        };
    });
    return (
        <div className="view-reviews-histogram">
            <div className="tempur-reviews-facet-container">
                <div className={styles.tempurReviewsFacetHeader}>
                    {/* TODO(i18n): Use t tagged template: {t`Reviews`} */}
                    <h2 className={styles.tempurReviewTotal}>Reviews</h2>
                    <div className={styles.tempurReviewsFacetStars}>
                        <RatingGraphic
                            cardClass="reviews"
                            cardSize="large"
                            onlyStars={true}
                            rating={averageScore}
                            starHasStroke={true}
                        />
                    </div>
                    {/* TODO(i18n): Translate complete sentence with interpolation: {t`(${roundReviewRating(averageScore)} out of 5) ${formatNumber(totalCount)} reviews`} */}
                    <p
                        className={classNames(
                            "caption-light",
                            styles.tempurReviewFacetStarText,
                        )}
                    >
                        ({roundReviewRating(averageScore)} OUT OF 5){" "}
                        {formatNumber(totalCount)} REVIEWS
                    </p>
                </div>
                <div className={styles.tempurReviewsTotalRatings}>
                    {histogram.map((row) => (
                        <HistogramRow
                            key={row.score}
                            row={row}
                            onRatingClick={(rating, event) => {
                                event.preventDefault();
                                dispatch(
                                    updateFilterOptionValue({
                                        facetType: FACET_TYPE,
                                        optionID: rating,
                                        isSelected: true,
                                        isExclusive: true,
                                    }),
                                );
                            }}
                            totalCount={totalCount}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};
